import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const ICON = (n) => `${import.meta.env.BASE_URL}img/s${n}-icon.png`;

/**
 * Reference result body for Unique Teenpatti (casino/teenunique):
 *   .row.row5.teenunique > .col-12.col-lg-7 > .casino-result-content
 *   > .casino-result-content-item.text-center.w-100 > .casino-result-cards.unique-teen20-box
 *   > 6 × .unique-teen20-card.casino-result-cards-item (s{n}-icon.png + card)
 * The column is only rendered when the round has cards.
 */
export default function TeenUniqueResultBody({ t1 }) {
  const raw = String(t1?.card ?? "");
  const cards = raw ? raw.split(",").map((c) => c.trim()) : [];

  return (
    <div className="row row5 teenunique">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards unique-teen20-box">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <React.Fragment key={i}>
                    {i > 0 && " "}
                    <div className="unique-teen20-card casino-result-cards-item">
                      <img src={ICON(i + 1)} alt="" /> <img src={getCardImage(cards[i])} />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
